/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ForgotCredentials } from "./forgotCredentials";
import { General } from "./general";
import { Layout } from "./layout";
import { RequestResetPassword } from "./requestResetPassword";
import { ResetPassword } from "./resetPassword";
import { SignIn } from "./signIn";
import { SignOut } from "./signOut";
import { ChangePassword } from "./changePassword";
import { AccountSelfCreationSettings } from "./accountSelfCreationSettings";
import { AuthenticationSettings } from "./authenticationSettings";
import { CreateNewUserSettings } from "./createNewUserSettings";
import { Settings } from "./settings";
import { MyProfile } from "./myProfile";
import { NavigationItems } from "./navigationItems";

class PageStrings {
    forgotCredentials: ForgotCredentials = new ForgotCredentials();
    general: General = new General();
    layout: Layout = new Layout();
    requestResetPasswordPage: RequestResetPassword = new RequestResetPassword();
    resetPasswordPage: ResetPassword = new ResetPassword();
    signInPage: SignIn = new SignIn();
    signOutPage: SignOut = new SignOut();
    changePassword: ChangePassword = new ChangePassword();
    accountSelfCreationPage: AccountSelfCreationSettings = new AccountSelfCreationSettings();
    authenticationPage: AuthenticationSettings = new AuthenticationSettings();
    createNewUserPage: CreateNewUserSettings = new CreateNewUserSettings();
    settingsPage: Settings = new Settings();
    myProfilePage: MyProfile = new MyProfile();
    navigationItems: NavigationItems = new NavigationItems();
}
export default PageStrings;
